define('core/mixins/withChannelFollowing',[
    'underscore',
], function (
    _
) {
    'use strict';

    // Return the mixin properties and functions with a closure around
    // the getChannel function, specified on a per-mixin basis
    function getChannelFollowButtonWrapperView(getChannel) {
        return {
            events: {
                'click [data-action=toggle-follow]': 'toggleFollow',
            },

            initialize: function () {
                this.bindToPrimaryForum();
            },

            templateHelpers: function () {
                return {
                    isFollowing: this.getIsFollowing(),
                };
            },

            bindToPrimaryForum: function () {
                var channelModel = getChannel.call(this);
                if (!channelModel)
                    return;

                if (!channelModel.primaryForum)
                    return void this.listenToOnce(channelModel, 'changeRelated:primaryForum', this.bindToPrimaryForum);

                this.listenTo(channelModel.primaryForum, 'change:isFollowing', this.updateFollowedState);
            },

            updateFollowedState: function () {
                this.$('[data-action=toggle-follow]').toggleClass('active', this.getIsFollowing());
            },

            getIsFollowing: function () {
                var channelModel = getChannel.call(this);
                return channelModel && channelModel.primaryForum && channelModel.primaryForum.get('isFollowing');
            },

            toggleFollow: function (evt) {
                if (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }

                var channelModel = getChannel.call(this);

                // Shouldn't ever take so long to fetch the primary forum that the user
                // has time to click on the follow button, but if it happen, don't want
                // to toggle the follow state since the state showing to the user may
                // be incorrect
                if (!channelModel || !channelModel.primaryForum)
                    return;

                // Forum's toggleFollowed will account for channels that should be followed
                // directly
                channelModel.primaryForum.toggleFollowed();

                // Allow project specific callbacks when toggle follow occurs, specifically
                // when it doesn't return early
                this.trigger('toggled:follow', evt);
            },
        };
    }

    function withChannelFollowing(_getChannel) {
        // A function to get the channel model for this view. If a special getter
        // is not given, channel is assumed to be the view's model.
        // This is passed to all the ChannelFollowButtonWrapperView functions that
        // require the channel model.
        var getChannel = _getChannel || function () {
            return this.model;
        };

        var ChannelFollowButtonWrapperView = getChannelFollowButtonWrapperView(getChannel);

        this.initialize = _.wrap(this.initialize, function (_initialize, options) {
            _initialize.call(this, options);
            ChannelFollowButtonWrapperView.initialize.call(this, options);
        });

        this.templateHelpers = _.wrap(this.templateHelpers, function (_templateHelpers) {
            var helpers = _.isFunction(_templateHelpers) ?
                _templateHelpers.call(this) :
                _templateHelpers;

            return _.extend(
                ChannelFollowButtonWrapperView.templateHelpers.call(this),
                helpers);
        });

        this.bindToPrimaryForum = _.wrap(this.bindToPrimaryForum, function (_bindToPrimaryForum) {
            if (_bindToPrimaryForum)
                _bindToPrimaryForum.call(this);

            ChannelFollowButtonWrapperView.bindToPrimaryForum.call(this);
        });

        this.events = _.extend({}, ChannelFollowButtonWrapperView.events, this.events);

        _.extend(this, _.pick(ChannelFollowButtonWrapperView,
            'updateFollowedState',
            'getIsFollowing',
            'toggleFollow'));
    }

    return withChannelFollowing;
});

